import React, { useState } from 'react'
import { DesignedModal } from '@clickcease/cc-client-components-lib'
import 'react-phone-input-2/lib/style.css'
import { useTranslation } from 'react-i18next'
import HubspotForm from './HubspotForm'
import {
  ScheduleCallModalStyled,
  ScheduleCallModalTitle,
  ScheduleCallModalSubTitle,
} from 'Features/ScheduleCallModal/ScheduleCallModal.styled'

interface ScheduleCallModalProps {
  isOpen?: boolean
  onOpenChange: (a: boolean) => void
}

export const ScheduleCallModal = ({ isOpen, onOpenChange }: ScheduleCallModalProps) => {
  const { t } = useTranslation('scheduleCall')
  const [showTitle, setShowTitle] = useState(true)

  return (
    <DesignedModal
      title={''}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      style={{ textAlign: 'center', zIndex: 1000, borderRadius: '1rem' }}
      hideBorderBottom={true}
    >
      <ScheduleCallModalStyled>
        {showTitle && (
          <>
            <ScheduleCallModalTitle>{t('title')}</ScheduleCallModalTitle>
            <ScheduleCallModalSubTitle>{t('subTitle')}</ScheduleCallModalSubTitle>
          </>
        )}
        <HubspotForm setShowTitle={setShowTitle} />
      </ScheduleCallModalStyled>
    </DesignedModal>
  )
}
